module.exports = __webpack_public_path__ + "img/crypto-teth.95f83a18.svg";